import React, { useState, useEffect } from 'react'
import { Container } from 'react-bootstrap'
import Fade from 'react-reveal/Fade'
import styled from 'styled-components'

import { media } from './util/media-queries'

const ButtonContainer = styled.div`
  display: flex;
  ${media.mobile`
    flex-direction: column;
  `}
  ${media.tablet`
    flex-direction: row;
  `}
`

const Subtitle = styled.p`
  font-family: 'Montserrat', sans-serif;
  text-align: left;
  margin-bottom: 5rem;
  margin-top: 4rem;
  max-width: 925px;
  ${media.mobile`
    margin-bottom: 4rem;
    margin-top: 1rem;
  `}
`

const Link = styled.a`
  font-family: 'Montserrat', sans-serif;
  font-weight: 600;
  color: #ffffff;
  border-bottom: 1.5px solid #1ebbd7;
  &:hover {
    border-color: #1ebbd7;
  }
`
const Header = () => {
  const [isDesktop, setIsDesktop] = useState(false)
  const [isMobile, setIsMobile] = useState(false)

  useEffect(() => {
    if (window.innerWidth > 769) {
      setIsDesktop(true)
      setIsMobile(false)
    } else {
      setIsMobile(true)
      setIsDesktop(false)
    }
  }, [])

  return (
    <section id="hero" className="jumbotron">
      <Container style={{display: 'flex', flexDirection: 'column', justifyContent: 'center', padding: 30, maxWidth: 1000  }} >
      <div style={{height: '100%', width: '100%', position: 'absolute', top: 0, left: 0, backgroundColor: 'black', opacity: 0.6}} />
        <Fade
          left={isDesktop}
          bottom={isMobile}
          duration={1000}
          delay={500}
          distance="30px">
          <h1 className="hero-title">
            Climbing Kilimanjaro to Help Fight Cancer
          </h1>
          <Subtitle>
            In August 2021, I'll be participating the "
            <Link
              href="https://secure.acsevents.org/site/STR?pg=entry&fr_id=97733"
              target="_blank"
              rel="noopener noreferrer">
              Kilimanjaro Climb
            </Link>
            ," an event organized by the{' '}
            <Link
              href="https://secure.acsevents.org/site/STR?pg=entry&fr_id=97733"
              target="_blank"
              rel="noopener noreferrer">
              American Cancer Society
            </Link>{' '}
            that raises money to eliminate cancer and improve the lives of those
            impacted by this terrible disease.
            <br />
            <br />
            I've set a fundraising goal of{' '}
            <Link
              target="_blank"
              rel="noopener noreferrer"
              href="https://secure.acsevents.org/site/SPageServer?pagename=active_donate_now&PROXY_TYPE=20&PROXY_ID=42479592&FR_ID=97733&fr_id=97733">
              $12,500
            </Link>{' '}
            in support of the ACS and will be climbing in memory of my dad,{' '}
            <Link
              target="_blank"
              rel="noopener noreferrer"
              href="https://www.montclairlocal.news/2019/06/25/obituary-gary-d-trabka-montclair-nj/">
              Gary
            </Link>
            , who lost his battle in June 2019.
          </Subtitle>
        </Fade>
        <Fade
          left={isDesktop}
          bottom={isMobile}
          duration={1000}
          delay={1000}
          distance="30px">
          <ButtonContainer>
            <p className="hero-cta">
              <a className="cta-btn cta-btn--hero" href="#why">
                Why I'm Climbing
              </a>
            </p>
            <p className="hero-cta">
              <a className="cta-btn cta-btn--hero" href="#about">
                Learn More
              </a>
            </p>
            <p className="hero-cta">
              <a
                className="cta-btn cta-btn--donate"
                target="_blank"
                rel="noopener noreferrer"
                href="https://secure.acsevents.org/site/SPageServer?pagename=active_donate_now&PROXY_TYPE=20&PROXY_ID=42479592&FR_ID=97733&fr_id=97733">
                Donate
              </a>
            </p>
          </ButtonContainer>
        </Fade>
      </Container>
    </section>
  )
}

export default Header
